import mixpanel from 'mixpanel-browser';

export default defineNuxtPlugin(() => {
  const mixPanelToken = useRuntimeConfig().public.MIXPANEL_TOKEN;

  mixpanel.init(mixPanelToken || 'd8038d374838b13ef8ac565b08be6135', {
    debug: true,
    ignore_dnt: true,
  });

  return {
    provide: {
      mixpanel,
    },
  };
});
